import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Building } from '../building.interface';
import { BuildingOptionsAction } from './building-options.interface';
import { BuildingService } from '../building.service';
import { takeUntil, map } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'sg2-building-options',
  templateUrl: './building-options.component.html',
  styleUrls: ['./building-options.component.less']
})
export class BuildingOptionsComponent implements OnDestroy, OnInit {

  /** All available options. */
  private readonly OPTIONS_DEFAULT = ['changeOrder', 'setRatioAs', 'setRatioBy'];

  /** Building. */
  @Input() building: Building;

  /** Disabled state of menu. */
  @Input() disabled: boolean;

  /** Set custom selection of options. */
  @Input() options: string[];

  /** Dispatch action. @deprecated */
  @Output() action = new EventEmitter<BuildingOptionsAction>();


  /** Configuration. */
  public config: {
    changeOrder?: boolean;
    setRatioAs?: boolean;
    setRatioBy?: boolean;
  } = {};

  /** Destroy hook. */
  private destroy$ = new Subject<any>();

  /** Constructor. */
  constructor(
    private buildingService: BuildingService
  ) { }

  /** Set options on init. */
  ngOnInit(): void {
    this._trackBuilding();
    this._setOptions();
  }

  /** Unsubscribe on destroy. */
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /**
   * Toggle the 'change order' mode.
   */
  public changeOrder(): void {
    this.action.emit({ action: 'changeOrder' });
  }

  /**
   * Toggle between *Ratio* and *BVO*.
   *
   * @param ratioAs Track ratio as.
   */
  public setRatioAs(ratioAs: Building['ratioAs']): void {
    this.buildingService.setRatioAs(this.building, ratioAs);
    // this.action.emit({ action: 'setRatioAs', ratioAs: ratioAs });
  }

  /**
   * Toggle between *Building* and *Cluster*.
   *
   * @param ratioAs Track ratio by.
   */
  public setRatioBy(ratioBy: Building['ratioBy']): void {
    this.buildingService.setRatioBy(this.building, ratioBy);
    // this.action.emit({ action: 'setRatioBy', ratioBy: ratioBy });
  }

  /**
   * Set menu options.
   *
   * A custom selection of options can be added by using the options binding.
   * When no options are given, all the options are shown.
   */
  private _setOptions(): void {
    this.options = this.options || this.OPTIONS_DEFAULT;
    this.options.forEach(o => {
      this.config[o] = true;
    });
  }

  /**
   * Track building from the Building observable.
   *
   * Match the current building by id, so only the building instead of the whole
   * Buildings array is received.
   */
  private _trackBuilding(): void {
    this.buildingService.building$.pipe(
      takeUntil(this.destroy$),
      map(buildings => buildings.filter(building => building._id === this.building._id)[0])
    ).subscribe(building => {
      this.building = building;
    });
  }
}
